import moment from 'moment';
import { createSelector } from 'reselect';

import { FILTERS_CACHE_EXPIRY } from '@src/utils/constants';

import { SCOPE } from './types';

const selector = (state) => state[SCOPE];

export const isCacheValidSelector = createSelector(
  selector,
  ({ dataCachedAt }) =>
    dataCachedAt && moment().diff(dataCachedAt, 'minutes') < FILTERS_CACHE_EXPIRY,
);

export default selector;
